<template>
    <div v-if="loading" class="row">
        <div class="col-lg-2 col-md-3 col-sm-4 col-4">
            <div class="div-body">
                <div class="mb-2 skeleton-box" style="width: 40px; height: 40px;"></div>
                <div class="skeleton-box" style="width: 100px; height: 21px;"></div>
            </div>
        </div>
    </div>
    <div v-if="products.length > 0 && !loading" class="row">
        <div v-for="(product, index) in products" :key="index" class="col-lg-2 col-md-3 col-sm-4 col-4">
            <div v-if="index < 5" class="div-body" @click.prevent="goToProductDetail(product.id)">
                <img :src="product.image_url" class="mb-2" width="40" height="40" />
                <small class="text-center">{{ product.current_name }}</small>
            </div>
            <div v-if="index == 5" class="div-body" @click.prevent="goToProductList(slug)">
                <font-awesome-icon icon="bars" class="mb-2" style="height: 40px; width: 40px;" />
                <small class="text-center">{{ $t('More') }}</small>
            </div>
        </div>
    </div>
    <div v-if="products.length == 0 && !loading" class="row">
        <div class="col-lg-2 col-md-3 col-sm-4 col-4">
            <div class="div-body">
                <img src="@/assets/images/icon-comingsoon.gif" class="mb-2" height="40" />
                <small class="text-center">{{ $t('Coming Soon!') }}</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeProductCardList",
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        slug: {
            type: String,
            required: true,
        },
        products: {
            type: Array,
            required: true,
        },
        branch_id: {
            type: String,
            required: false,
        },
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },

        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        //
    },
    methods: {
        goToProductDetail(id) {
            let allowed = false;
            if (this.slug == 'company') {
                if (
                    this.currentCompany &&
                    // this.currentCompany.verified_at != null &&
                    (this.currentCompany.total_branches > 0)
                ) {
                    allowed = true;
                } else {
                    allowed = false;
                    // if (this.currentCompany && this.currentCompany.verified_at == null) {
                    //     this.$vueAlert.alert(this.$t("Please wait for your company data to be verified!"), null, 'warning');
                    // } else 
                    if (this.currentCompany && this.currentCompany.total_branches == 0) {
                        this.$vueAlert.alert(this.$t("Please add your destination first!"), null, 'warning');
                    } else {
                        this.$vueAlert.alert(this.$t("Please register your company first!"), null, 'warning');
                    }
                }
            } else {
                allowed = true;
            }

            if (allowed) {
                this.$router.push({
                    name: "Product Detail",
                    query: {
                        id: id,
                        type: this.$encryptString(this.slug, 'encryptKey'),
                    },
                });
            }
        },

        goToProductList(slug) {
            this.$router.push({
                name: "Product List",
                query: {
                    slug: slug,
                },
            });
        },
    },
}
</script>

<style scoped>
.skeleton-box {
    background-color: #e6e6e6;
    border-radius: 4px;
}

.div-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.div-body>* {
    cursor: pointer;
}
</style>